export default function isValueValid(value: number, minValue: number, maxValue: number) {
  if (value > maxValue || value < minValue) {
    return false;
  }
  return true;
}
